import { NbDateFnsOptions } from '@nebular/date-fns';
import { it } from 'date-fns/locale';

export const dateFnsConfig: NbDateFnsOptions = {
  format: 'dd/MM/yyyy',
  parseOptions: { locale: it },
  formatOptions: { locale: it },
  getWeekOptions: {}
};
